import { FC, useMemo, useCallback, ReactNode } from 'react';
import { Form } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getSearchState } from 'src/store/search/selectors';
import { searchActions } from 'src/store/search/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface SearchFiltersFormValues {
  from: string | undefined;
  to: string | undefined;
}

export interface SearchFiltersFormProps {
  children?: ReactNode;
}

export const SearchFiltersForm: FC<SearchFiltersFormProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { from, to } = useSelector(getSearchState);

  const initialValues = useMemo(
    (): SearchFiltersFormValues => ({
      from,
      to,
    }),
    [from, to],
  );

  const applyFilters = useCallback(
    (values: SearchFiltersFormValues) => {
      dispatch(searchActions.applyFilters(values));
    },
    [dispatch],
  );

  return (
    <Form onSubmit={applyFilters} initialValues={initialValues}>
      {() => children}
    </Form>
  );
};
